// extracted by mini-css-extract-plugin
export default {"button":"AddCompanyButton_button__fB0Dd"};